import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ typography }: Theme) =>
  createStyles({
    formContainerSpace: {
      paddingBottom: 10,
    },
    formContent: {
      margin: '20px 0 0',
    },

    titleContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      margin: '16px 0 8px',
      paddingBlock: '4px !important',
    },
    switchContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    load: {
      marginLeft: 380,
    },

    switchChecked: {
      '&.Mui-checked': {
        color: palette.green,

        '& + .MuiSwitch-track': {
          backgroundColor: palette.green,
        },
      },
    },
    switchLabel: {
      fontSize: 12,
    },
    switchRoot: {
      marginRight: 8,
    },

    smallFieldsWrap: {
      '& .MuiOutlinedInput-inputMultiline': {
        minHeight: 160,
      },
    },

    buttonsCustomMargin: {
      margin: '24px 0 0',
    },
    buttons: {
      margin: '40px auto',

      '& .MuiButtonBase-root': {
        fontFamily: 'Roboto',
        minWidth: 90,
        padding: 6,
        margin: '0 8px',
        fontSize: 12,
        fontWeight: typography.fontWeightMedium,
        borderRadius: 4,
      },
    },
    buttonCancel: {
      border: `1px solid ${palette.gray}`,
      color: palette.gray,
    },
    buttonConfirm: {
      border: `1px solid ${palette.green}`,
      backgroundColor: palette.green,
      color: palette.white,
    },

    buttonDelete: {
      border: `1px solid ${palette.red}`,
      backgroundColor: palette.red,
      color: palette.white,
    },

    alert: {
      maxWidth: 600,
      margin: '40px auto',
      width: 'fit-content',
      fontSize: 12,
      '& b': {
        fontWeight: 900,
      },
    },
    applications: {
      padding: '17px 0px 13px 9px',
    },
    applicationsTitle: {
      fontSize: 14,
      fontWeight: 500,
      marginRight: 10,
    },
    footer: {
      display: 'block',
      justifyContent: 'flex-end',
      paddingRight: '12px',
    },
    buttonsBase: {
      borderTop: `1px solid ${palette.borderGray}`,
      justifyContent: 'right',
    },
    buttonsAlign: {
      justifyContent: 'flex-end',
      display: 'flex',
      padding: '10px 0px 4px',
    },
    formContainer: {
      margin: 0,
    },
    applicationsGrid: { display: 'contents' },
    spotThreshold: { fontSize: 14, margin: '20px 0px 0px 25px' },
    spotGrid: {
      '& .MuiFormControl-root': {
        width: '98% !important',
        marginLeft: '7px !important',
      },
    },
    statusSection: {
      '& fieldset': {
        borderColor: palette.deepBlue,
      },
    },
    statusGrid: { margin: '0px !important', alignItems: 'center' },
    completionDateField: {
      fontSize: 14,
      color: palette.darkGray,
      fontWeight: 600,
    },
    dateAndPending: { display: 'flex', alignItems: 'center' },
    dateAndPendingGrid: {
      display: 'flex',
      alignItems: 'center',
    },
    alarmIcon: { color: palette.green, cursor: 'pointer', margin: '0px 4px' },
    setProduction: {
      border: `1px solid ${palette.green}`,
      borderRadius: 16,
      marginLeft: 18,
      color: palette.green,
      width: 280,
    },
    setExtend: {
      border: `1px solid ${palette.blue}`,
      borderRadius: 16,
      margin: '0px 6px',
      color: palette.blue,
      width: 150,
    },
    divider: { border: `1px solid ${palette.darkGray}` },
    displayFlex: {
      display: 'flex',
      margin: 0,
      '& .MuiSvgIcon-root': { cursor: 'pointer' },
    },
    pending: {
      fontSize: 14,
      color: palette.orange,
      fontWeight: 500,
      alignContent: 'center',
      display: 'flex',
      marginLeft: 8,
    },
    pendingIcon: { marginLeft: 4, fontSize: 18, color: palette.orange },
    validatePending: {
      border: `1px solid ${palette.orange}`,
      borderRadius: 16,
      color: palette.orange,
      width: 200,
      marginLeft: 8,
    },
    statusGeneric: {
      width: 210,
      marginRight: 60,
      '& .MuiInputBase-root': { width: 250 },
    },
    dateGrid: { '& .MuiFormControl-root': { width: 250 } },
    pendency: {
      border: `1px solid ${palette.orange}`,
      borderRadius: 16,
      margin: 8,
    },
    approvePendency: { color: palette.green, marginRight: 16 },
    refusePendency: {
      color: palette.red,
      marginRight: 16,
      visibility: 'hidden',
    },
    tenancySwitchRoot: {
      marginLeft: -4,
    },
    fields: {
      '& .MuiFormControl-fullWidth': { margin: '6px 0px' },
      '& .MuiOutlinedInput-multiline': { display: 'inline-table', padding: 14 },
    },
    currentTime: {
      marginLeft: 16,
      '& .MuiOutlinedInput-input': { textAlign: 'center' },
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        color: palette.deepBlue,
      },
      '& .MuiOutlinedInput-root': { color: palette.deepBlue, fontWeight: 500 },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.deepBlue,
        border: `2px solid ${palette.deepBlue}`,
      },
      '& .MuiFormControl-root': { width: '100%' },
    },
    currentPin: {
      '& .MuiOutlinedInput-input': { textAlign: 'center' },
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        color: palette.deepBlue,
      },
      '& .MuiOutlinedInput-root': { color: palette.deepBlue, fontWeight: 500 },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.deepBlue,
        border: `2px solid ${palette.deepBlue}`,
      },
      '& .MuiFormControl-root': { width: '100%' },
    },
    currentPinGrid: {
      marginTop: 16,
    },
    publicationContainer: {
      margin: 8,
      alignItems: 'center',
      '& .MuiFormControl-root': { width: '100%' },
      '& .MuiFormHelperText-contained': { color: palette.red },
    },
    publicationHeader: { display: 'flex', alignItems: 'center' },
    useLimitDailyText: { fontSize: 14 },
    publicationCheckbox: { marginLeft: 8 },

    infoIcon: {
      width: 16,
      height: 16,
    },
  });

export const overrideSlider = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: '8px  0px',
    marginLeft: '35px',
    '& .MuiSlider-root': {
      width: '100%',
      color: palette.green,
    },
  },
};
